/* eslint prefer-promise-reject-errors: "off" */
// import {
//   // PTTSendClick,
//   // PTTSendReport,
//   reportPop,
//   reportClick,
//   reportV4Click,
//   reportV4Pop,
// } from '@utils/report.js';
import { replaceImgToCloud } from '@utils/cloud-img.js';

import { isEmpty, isNotEmpty, isString } from '@tencent/slug-function';

const lodingImg = require('@img/loading.jpg');
const load = url => new Promise((resolve, reject) => {
  let img = new Image();
  img.src = url;
  img.onload = () => {
    img = null;
    resolve(url);
  };
  img.onerror = () => {
    console.warn(`img load error: => '${url}'`);
    img = null;
    reject();
  };
});
const balckFilter = async (el, value) => {
  try {
    if (!window.DOMPurify) {
      const DOMPurify = await import(
        /* webpackChunkName: "dompurify" */ 'dompurify');
      window.DOMPurify = DOMPurify.default || DOMPurify;
    }
    if (isString(value)) {
      el.innerHTML = window.DOMPurify.sanitize(value);
      return;
    }
    const config = value.config || {};
    const hook = value.hook || {};
    if (isNotEmpty(hook)) {
      for (const key of Object.keys(hook)) {
        window.DOMPurify.addHook(key, hook[key]);
      }
    }
    el.innerHTML = window.DOMPurify.sanitize(value.dirty, config);
  } catch (err) {
    console.log(err);
  }
};

export default (Vue) => {
  Vue.directive('src', (el, binding) => {
    const { url, defaultUrl, rule } = binding.value;
    if (!el.setDefault) {
      if (defaultUrl) {
        el.src = defaultUrl;
      } else {
        el.src = lodingImg;
      }
      el.setDefault = true;
    }
    if (!url) return;
    binding.value.url = replaceImgToCloud(url, rule);
    load(binding.value.url)
      .then((res) => {
        el.src = res;
      })
      .catch(() => { });
  });
  Vue.directive('ptt', {
    bind(el, { value = [] }) {
      if (el.isEvent === true) return;
      // console.log('ptt-', value);
      el.isEvent = true;
      el.addEventListener(
        'touchstart',
        () => {
          window.PTTSendClick && window.PTTSendClick(...value);
        },
        false,
      );
    },
  });
  Vue.directive(
    'black-html',
    async (el, { value, oldValue, modifiers = {} }) => {
      if (value === undefined) return;
      if (value === oldValue) return;
      const once = modifiers.once || false;
      if (el.isEvent) return;
      await balckFilter(el, value);
      if (once === true) el.isEvent = true;
    },
  );

  // const whiteFilter = async (el, value) => {
  //   try {
  //     if (!window.filterXSS) {
  //       const filterXSS = await import(/* webpackChunkName: "xss" */ 'xss');
  //       window.filterXSS = filterXSS.default || filterXSS;
  //     }
  //     if (isString(value)) {
  //       el.innerHTML = window.filterXSS(value);
  //       return;
  //     }
  //     const options = value.options || {};
  //     el.innerHTML = window.filterXSS(value, options);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // Vue.directive('bg', (el, binding) => {
  //   const { url, defaultUrl, rule } = binding.value;
  //   if (!el.setDefault) {
  //     if (defaultUrl) {
  //       el.style.backgroundImage = `url(${defaultUrl})`;
  //     } else {
  //       el.style.backgroundImage = `url(${lodingImg})`;
  //     }
  //     el.setDefault = true;
  //   }
  //   if (!url) return;
  //   binding.vaule.url = replaceImgToCloud(url, rule);
  //   load(url)
  //     .then((res) => {
  //       el.style.backgroundImage = `url(${res})`;
  //     })
  //     .catch(() => { });
  // });
  // 添加播放按钮，用法：v-icon="'play' / v-icon="{name:'play', show:false}" / v-icon
  // Vue.directive('icon', (el, binding) => {
  //   // 阻止重复调用
  //   if (el[`isSet${binding.name}`] === true) return;
  //   let isShown = true;
  //   let iconName;
  //   if (typeof binding.value === 'object') {
  //     const { show, name } = binding.value;
  //     iconName = name;
  //     isShown = typeof show === 'boolean' ? show : true;
  //   } else {
  //     iconName = binding.value;
  //   }
  //   el[`isSet${binding.name}`] = true;
  //   const icon = document.createElement('I');
  //   // 分情况处理
  //   switch (iconName) {
  //     case 'play': // 播放按钮
  //     default:
  //       if (!isShown) {
  //         return;
  //       }
  //       icon.className = 'icon_bo';
  //       el.appendChild(icon);
  //       break;
  //   }
  // });
  // Vue.directive('opacity', (el, { value }) => {
  //   if (value) {
  //     el.style.opacity = 1;
  //     return;
  //   }
  //   el.style.opacity = 0;
  // });
  // ptt点击上报

  // ptt点击上报 v2 (响应式)
  // Vue.directive('ptt-v2', {
  //   bind(el) {
  //     if (el.isEvent === true) return;
  //     el.isEvent = true;
  //     el.addEventListener(
  //       'touchstart',
  //       () => {
  //         if (el.dataset.ptt) {
  //           // eslint-disable-next-line new-cap
  //           window.PTTSendClick && window.PTTSendClick(...el.dataset.ptt.split(','));
  //         }
  //       },
  //       false,
  //     );
  //   },
  // });
  // v4和用户行为曝光上报
  // Vue.directive('v4pop', {
  //   bind: (el) => {
  //     el.cache = [];
  //   },
  //   update: (el, { value = [], oldValue = [] }) => {
  //     const [v4ExtParams, useractionExtParams, list] = value;
  //     const [, , olist] = oldValue;
  //     if (isEmpty(list)) return;
  //     el.bindReportPop = function (coordinate) {
  //       try {
  //         const scrollTop = Math.abs(coordinate.y);
  //         let items = [];
  //         // list = value[2],
  //         const listNum = list.length;
  //         const ul = el.querySelector('.v4-list');
  //         const li = ul.querySelector('.v4-list-item');
  //         // 每行item数目
  //         const perlineNum = Math.round(ul.clientWidth / li.clientWidth);
  //         // 每行高度
  //         const perLineHeight = ul.clientHeight / (listNum / perlineNum);
  //         // 一屏多少行
  //         const lineNum = Math.round(el.clientHeight / perLineHeight);
  //         const perScreenNum = perlineNum * lineNum;
  //         // 滑动结束计算index,需要根据[this.$refs.scrollWarp,this.$refs.videoItem.$el]计算出[每行item数目,每屏item数目,scrollTop,所有item]
  //         const startIndex = Math.round(scrollTop / perLineHeight) * perlineNum;
  //         if (startIndex < listNum) {
  //           items = list.slice(startIndex, startIndex + perScreenNum);
  //         } else {
  //           items = list.slice(listNum - 1);
  //         }
  //         items = items.filter(item => el.cache.indexOf(item.iVideoId || item.iNewsId) == -1);
  //         if (isEmpty(items)) return;
  //         reportPop(v4ExtParams, useractionExtParams, items);
  //         items.forEach((item) => {
  //           el.cache.push(item.iVideoId || item.iNewsId);
  //         });
  //       } catch (err) {
  //         console.log(err);
  //       }
  //     };
  //     if (isEmpty(olist) && isNotEmpty(list)) {
  //       // 首屏上报
  //       Vue.nextTick(() => {
  //         el.bindReportPop({
  //           x: 0,
  //           y: 0,
  //         });
  //       });
  //     }
  //   },
  // });
  // v4点击上报
  // Vue.directive('v4click', {
  //   bind: (el) => {
  //     el.v4clickCache = [];
  //   },
  //   update: (el, { value = [] }) => {
  //     const [v4ExtParams, useractionExtParams, list] = value;
  //     if (isEmpty(list)) return;
  //     // 代理到ul上
  //     el.addEventListener('click', (e) => {
  //       try {
  //         const ul = Array.prototype.slice.call(e.currentTarget.children);
  //         let li = e.target;
  //         while (li.className.indexOf('v4-list-item') === -1) {
  //           li = li.parentNode;
  //         }
  //         const index = ul.indexOf(li);
  //         const reportItem = list[index];
  //         // id = reportItem.iVideoId || reportItem.iNewsId;
  //         const id = index + 1;
  //         if (el.v4clickCache.indexOf(id) !== -1) return;

  //         reportClick(v4ExtParams, useractionExtParams, reportItem);
  //         el.v4clickCache.push(id);
  //       } catch (err) {
  //         console.log(err);
  //       }
  //     });
  //   },
  // });
  // ptt上报
  // Vue.directive('ptt-report', {
  //   bind(el, { value = {} }) {
  //     const params = Object.assign({}, value);
  //     const { hottag, fortest, dmp } = params;
  //     if (!fortest) {
  //       params.fortest = Object.assign({}, { fortest1: '', fortest2: '' });
  //     }
  //     if (hottag.pop) {
  //       const arr = hottag.pop.split('_');
  //       // eslint-disable-next-line prefer-destructuring
  //       const action = arr[0];
  //       // eslint-disable-next-line new-cap
  //       PTTSendReport({
  //         action,
  //         hottag: hottag.pop,
  //         targetid: dmp.targetid,
  //         targettype: dmp.targettype,
  //         title: dmp.title,
  //         from: dmp.from,
  //         fortest1: fortest.fortest1,
  //         fortest2: fortest.fortest2,
  //       });
  //     }

  //     if (hottag.click) {
  //       const arr = hottag.click.split('_');
  //       const action = arr[0];
  //       el.addEventListener(
  //         'click',
  //         () => {
  //           // eslint-disable-next-line new-cap
  //           PTTSendReport({
  //             action,
  //             hottag: hottag.click,
  //             targetid: dmp.targetid,
  //             targettype: dmp.targettype,
  //             fortest1: fortest.fortest1,
  //             fortest2: fortest.fortest2,
  //           });
  //         },
  //         false,
  //       );
  //     }
  //   },
  // });
  // eas上报
  // Vue.directive('eas-report', {
  //   bind(el, { value = {} }) {
  //     const params = Object.assign({}, value);
  //     reportV4Pop(params);
  //     el.addEventListener(
  //       'click',
  //       () => {
  //         reportV4Click(params);
  //       },
  //       false,
  //     );
  //   },
  // });
  // xss过滤之白名单过滤
  // 用法1:默认过滤
  // v-white-html="dirty"
  // 用法2:自定义过滤
  // v-white-html="{dirty:String,options:Object}"
  // Vue.directive(
  //   'white-html',
  //   async (el, { value, oldValue, modifiers = {} }) => {
  //     if (value === undefined) return;
  //     if (value === oldValue) return;
  //     const once = modifiers.once || false;
  //     if (el.isEvent) return;
  //     await whiteFilter(el, value);
  //     if (once === true) el.isEvent = true;
  //   },
  // );
  // xss过滤之黑名单过滤
  // 用法1:默认过滤
  // v-black-html="dirty"
  // 用法2:自定义过滤
  // v-black-html="{dirty: String,config: Object, hook:{beforeSanitizeElements:Function}}"
};
